module.exports = __webpack_public_path__ + "img/box-arrow-up-right.335ea2f3.svg";